<template>
  <div>
    <svg
      id="g255"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      :width="size"
      :height="size"
      viewBox="0 0 30 30"
    >
      <defs>
        <clipPath id="clip-path">
          <path
            id="path261"
            class="cls-1"
            d="M0-682.665H29.293v30.337H0Z"
            transform="translate(0 682.665)"
          />
        </clipPath>
      </defs>
      <g id="g257">
        <g id="g259" clip-path="url(#clip-path);">
          <g id="g265" transform="translate(0.572 18.724)">
            <path
              id="path267"
              fill="none"
              :stroke="color"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="10"
              stroke-width="2px"
              d="M0,0H10.642V3.733H12.53A1.748,1.748,0,0,1,14.246,5.51,1.748,1.748,0,0,1,12.53,7.288H10.642v3.733"
            />
          </g>
          <g id="g269" transform="translate(0.572 4.148)">
            <path
              id="path271"
              fill="none"
              :stroke="color"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="10"
              stroke-width="2px"
              d="M-317.753-313.423V-315.2a1.748,1.748,0,0,1,1.716-1.778,1.748,1.748,0,0,1,1.716,1.778v1.778h3.6V-302.4H-332v-22.042h3.6v-1.778A1.748,1.748,0,0,1-326.678-328a1.748,1.748,0,0,1,1.716,1.778v1.778h3.6v3.733h-1.888a1.748,1.748,0,0,0-1.716,1.778,1.748,1.748,0,0,0,1.716,1.778h1.888v3.733Z"
              transform="translate(331.999 327.999)"
            />
          </g>
          <g id="g273" transform="translate(14.646 0.593)">
            <path
              id="path275"
              :fill="color"
              d="M-76.567,0V3.733h-1.716A1.748,1.748,0,0,0-80,5.51a1.748,1.748,0,0,0,1.716,1.778h1.716v3.733h3.6V9.066a1.748,1.748,0,0,1,1.716-1.778A1.748,1.748,0,0,1-69.53,9.066v1.955h3.6V0Z"
              transform="translate(80)"
            />
          </g>
          <g id="g277" transform="translate(14.646 0.593)">
            <path
              id="path279"
              fill="none"
              :stroke="color"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="10"
              stroke-width="2px"
              d="M-76.567,0V3.733h-1.716A1.748,1.748,0,0,0-80,5.51a1.748,1.748,0,0,0,1.716,1.778h1.716v3.733h3.6V9.066a1.748,1.748,0,0,1,1.716-1.778A1.748,1.748,0,0,1-69.53,9.066v1.955h3.6V0Z"
              transform="translate(80)"
            />
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Activity_Icon",
  props: {
    color: {
      default: "#1C274C",
    },
    size: {
      default: 30,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
  },
};
</script>

<style>
</style>